import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-xing",
  "use": "social-media-xing-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\" id=\"social-media-xing\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"26\" cy=\"26\" r=\"26\" fill=\"#FFF\" /><path fill=\"#2d2d2d\" fill-rule=\"nonzero\" d=\"M28.083 37l-4.973-8.625L30.827 15h5.195l-7.718 13.375L33.277 37h-5.195zm-8.164-6.652l3.859-6.285-2.894-5.043h-4.897l2.893 5.043-3.858 6.285h4.897z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol